module.exports = __webpack_public_path__ + "media/bootstrap-icons/palette-fill-15a74e12.svg";